export const iconInfoClasses = "icon icon-icon-info";
